<app-organizer-shared-layout-dashboard-header
  class="organizer-shared-layout-dashboard__header"
></app-organizer-shared-layout-dashboard-header>

<main class="container mt-6">
  <header
    class="organizer-shared-layout-dashboard__subheader col-span-12 lg:col-span-5 lg:grid lg:grid-cols-5"
  >
    <div class="flex">
      <a
        class="text-2xl p-2 -ml-2 lg:mx-auto lg:mb-auto"
        [routerLink]="backLink"
        [queryParams]="backLinkParams"
        [attr.aria-label]="ariaLabel"
      >
        <vtmn-play-icon [name]="iconType.ArrowLeft"></vtmn-play-icon>
      </a>
    </div>

    <div class="lg:col-start-2 lg:col-span-4">
      <h2 class="title-4">{{ title }}</h2>
      <p class="text-grey">{{ subtitle }}</p>
      <ng-content select="[header-extra]"></ng-content>
    </div>
  </header>

  <div
    class="organizer-shared-layout-dashboard__container column col-span-12 mb-9 lg:col-span-5 lg:col-start-2 lg:mb-3"
  >
    <ng-content></ng-content>
  </div>
</main>
